import { plainToInstance } from 'class-transformer'
import { Entity } from '@core/entities/entity'
import { ICompanyOnboardingSubmission } from './ICompanyOnboardingSubmission'
import { ICompanySubmittedForm } from '@core/entities/company/CompanySubmittedForm'

const COMPANY_NAME_PROPERTY_ID = 'company_name'

export class CompanyOnboardingSubmission extends Entity<ICompanyOnboardingSubmission> {
  id: number
  organisationId: number
  companyId: number
  formData: ICompanySubmittedForm
  createdBy: number
  modifiedBy: number
  createdOn: string
  modifiedOn: string

  public static new(
    payload: ICompanyOnboardingSubmission,
  ): CompanyOnboardingSubmission {
    return plainToInstance(CompanyOnboardingSubmission, payload)
  }

  public getCompanyName(): string {
    const nameEntry = this.formData?.data?.find(
      (entry) =>
        entry.propertyId === COMPANY_NAME_PROPERTY_ID &&
        entry.type === 'STRING',
    )
    if (nameEntry && nameEntry.type === 'STRING') {
      return nameEntry.textValue || ''
    }
    return ''
  }
}
